document.addEventListener('DOMContentLoaded', () => {
  const reviewActions = document.querySelector('.review__actions');

  if (!reviewActions) return;

  const buttons = document.querySelectorAll('.review__action');
  const contents = document.querySelectorAll('.review__item');

  buttons.forEach((button, index) => {
    button.addEventListener('click', function () {
      // Remove active class from all buttons and contents
      buttons.forEach((btn) => btn.classList.remove('active'));
      contents.forEach((content) => content.classList.remove('active'));

      // Add active class to clicked button and corresponding content
      this.classList.add('active');

      if (contents[index]) {
        contents[index].classList.add('active');
      }
    });
  });
});
